import { DokumentUnterschrift } from '../../unterschrift/dokument-unterschrift'
import { useApp } from '@/core/state/appStore'
import { TeilnehmerakteStaffPanel } from './teilnehmerakte-staff-panel'

export function TeilnehmerakteStaffHost() {
  const { state, dispatch } = useApp()
  const view = state.screen
  const close = () => dispatch({ type: 'CLOSE' })
  if (!view || (view.kind !== 'akte' && view.kind !== 'dokumentUnterschrift')) return null
  if (view.kind === 'dokumentUnterschrift') {
    return (
      <DokumentUnterschrift
        key={`${view.dokument}:${view.participant.id}`}
        dokument={view.dokument}
        participant={view.participant}
        source={view.source}
        ansehen={view.ansehen}
        onClose={close}
      />
    )
  }
  const source = view.source ?? { kind: 'bar' }
  return (
    <TeilnehmerakteStaffPanel
      key={view.participant.id}
      participant={view.participant}
      source={source}
      onClose={close}
    />
  )
}
